// extracted by mini-css-extract-plugin
export var container = "_hi-1";
export var cornerButtonContainer = "_hi-6";
export var disabled = "_hi-2";
export var dragActive = "_hi-3";
export var fileContainer = "_hi-5";
export var hiddenInput = "_hi-4";
export var widthContainer = "_hi-0";